import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import UserProfile from './components/UserProfile';
import Login from './components/Login';
import Registration from './components/Registration';
import ForgotPassword from './components/ForgotPassword';
import ResetPasswordForm from './components/ResetPassword';
import AccountActivation from './pages/AccountActivation';
import Verify from './pages/Verify';
import Loginwithfayda from './components/AuthFayda.js';
import Logout from './components/Logout';

import { AuthProvider, useAuth } from './components/AuthContext';

import theme from './theme'; // Adjust this import according to where your theme is defined
import ForgotUsername from './components/ForgotUsename.jsx';
import FaydaProfile from './components/FaydaProfile';
import BackgroundIcons from './components/BackgroundIcons';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <AuthProvider>
          <BackgroundIcons />
          <AppContent />
        </AuthProvider>
      </Router>
    </ThemeProvider>
  );
}

function AppContent() {
  const { authStatus } = useAuth();

  return (
    <Routes>
      {authStatus ? (
        <>
          <Route path="/" element={<Navigate replace to="/registration" />} />
          <Route path="/profile" element={<UserProfile />} />
          <Route path="/logout" element={<Logout />} />
          <Route path="/reset-password/:token" element={<ResetPasswordForm />} />
          <Route path="/activate/:activationId/:activationToken" element={<AccountActivation />} />
          <Route path="*" element={<Navigate replace to="/profile" />} />
          <Route path="/verify/:userId" element={<Verify />} />
          <Route path="/verify/:user_tok" element={<Verify />} />
          <Route path="/fayda-profile" element={<FaydaProfile />} />
        </>
      ) : (
        <>
          <Route path="/" element={<Navigate replace to="/registration" />} />
          <Route path="/verify/:userId" element={<Verify />} />
          <Route path="/verify/:user_tok" element={<Verify />} />
          <Route path="/logout" element={<Logout />} />

          <Route path="/login" element={<Login />} />
          <Route path="/forgotpassword" element={<ForgotPassword />} />
          <Route path="/registration" element={<Registration />} />
          <Route path="/reset-password/:token" element={<ResetPasswordForm />} />
          <Route path="/activate/:activationId/:activationToken" element={<AccountActivation />} />
          <Route path="*" element={<Navigate to="/registration" />} />
          <Route path="/authfayda" element={<Loginwithfayda />} />
          <Route path="/forgot-username" element={<ForgotUsername />} />
          <Route path="/fayda-profile" element={<FaydaProfile />} />
        </>
      )}
    </Routes>
  );
}

export default App;
